import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { QBService } from '../../data/qb.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Project } from '../../../project-misc/data/project/project';
import { ProjectSale } from '../../data/project-sale';
import { InputNumber } from 'primeng/inputnumber';
import { timer } from 'rxjs';

@Component({
    selector: 'app-create-estiinv-dialog',
    templateUrl: './create-estiinv-dialog.component.html',
    styleUrls: ['./create-estiinv-dialog.component.scss']
})
export class CreateEstiinvDialogComponent implements OnInit {
    sale: ProjectSale;

    loadingSpinner = false;
    deleteLoadingSpinner = false;

    val1: string;

    inputAmount = null;

    choosedPercent = 0;

    @ViewChild('tagAmount', { static: false })
    tagAmount: InputNumber;

    values = [{
        value: '10 percent',
        label: 'Drawing deposit invoice - 10%',
        opt: 'op1',
        percent: 10
    }, {
        value: '50 percent',
        label: 'Production deposit invoice - 50%',
        opt: 'op2',
        percent: 50
    }, {
        value: '100 percent',
        label: 'Remaining balance invoice',
        opt: 'op3',
        percent: 100
    }, {
        value: 'Custom',
        label: 'Custom',
        opt: 'op4',
        percent: 0
    }]

    constructor(
        protected dialog: MatDialog,
        protected dialogRef: MatDialogRef<CreateEstiinvDialogComponent>,
        protected qbService: QBService,
        @Inject(MAT_DIALOG_DATA) public data: {
            sale: ProjectSale
            projectId: number
        }
    ) {
        this.sale = data.sale;
    }

    ngOnInit() {

    }


    createEstInv() {
        this.loadingSpinner = true;

        let useRemain = false;


        if (this.choosedPercent === 0) {
            this.choosedPercent = this.inputAmount;
        }
        else if (this.choosedPercent === 100) {
            useRemain = true;
            this.choosedPercent = 0;
        }

        this.qbService.createInvoiceForEstimate(this.data.projectId, this.sale.id, this.choosedPercent, useRemain).subscribe(invoice => {
            this.qbService.newInvoice$.next(invoice)

            this.dialogRef.close('Success!');

        }, error => {
            this.loadingSpinner = false;
            // this.openErrorSnackBar(error.message)
        })

    }

    radioChanged(event) {
        this.choosedPercent = event;

        if (this.choosedPercent === 0) {
            timer(1).subscribe(emit => {
                const tempInput = this.tagAmount.input.nativeElement as HTMLInputElement;
                if (tempInput) {
                    tempInput.focus()
                    // tempInput.setSelectionRange(1, 1);
                }
            })
        }
    }
}
